import React from "react"
import Select from "react-select"
import { ClearIndicator } from "./clear-indicator"
import { DropdownIndicator } from "./dropdown-indicator"
import { IInputSelect, Option } from "./model"

import "./style.scss"

/**
 * Text based input designed to take either text or a password.
 */
export function InputSelect({
    id,
    required,
    error,
    options,
    placeholder,
    active,
    label,
    onFocus,
    tooltip,
    clearable,
    searchable,
    disabled,
    callback,
    menuPlacement,
    style,
    className,
}: IInputSelect) {
    const handleChange = (value: Option | null) => {
        if (!disabled) {
            if (value === null) {
                callback({ value: undefined, label: undefined })
            } else {
                callback(value)
            }
        }
    }

    return (
        <div
            className={`ips 
        ${className || ""} 
        ${error ? "error" : ""} 
        ${disabled ? "disabled" : ""}
      `}
            style={style}
        >
            {label && (
                <label className="ips-label" htmlFor={id}>
                    {label}
                    {required && <strong>*</strong>}
                    {tooltip && <span>{tooltip}</span>}
                </label>
            )}
            <div className="ips-wrapper">
                <Select
                    classNamePrefix="ips"
                    name={id}
                    placeholder={placeholder}
                    components={{ DropdownIndicator, ClearIndicator }}
                    instanceId={id}
                    value={active}
                    isDisabled={disabled}
                    isClearable={clearable}
                    isSearchable={searchable}
                    onFocus={onFocus}
                    options={options}
                    className="ips-input"
                    onChange={handleChange}
                    menuPlacement={menuPlacement}
                />
            </div>
        </div>
    )
}

InputSelect.defaultProps = {
    placeholder: undefined,
    searchable: true,
}

export const getActiveFromValue = (value: string | undefined, optionList: Option[]) => {
    const foundList = optionList.filter((item: Option) => {
        return item.value === value
    })
    if (foundList.length === 0) {
        return undefined
    }

    return foundList[0]
}
